<template>
  <div>
    <div class="buttons">
      <router-link :to="{path: '/h/category/'}" class="back">
        <vk-icon icon="triangle-left" ratio="2"></vk-icon>
      </router-link>
      <span v-if="category">
        カテゴリ：{{ category.name }}
        ({{ category.items_count }}件)
      </span>
    </div>
    <div
      v-if="items.length > 0"
      class="items"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="1000"
    >
      <template v-for="item in items" >
        <ItemsItem  v-bind="item" :key="item.id" v-if="item.hasOwnProperty('id')"></ItemsItem>
      </template>
    </div>
    <div class="description" v-if="!loading && !items.length">
      このカテゴリにはアイテムが登録されていません
    </div>
    <div class="text-center mt-2 mb-2" v-if="!loading">
      <button class="btn btn-danger" @click="$router.push({path: '/contribution'})">希望のデザインがないのでリクエストする</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  // import { debounce } from 'lodash';
  import ItemsItem from './items/Item';
  export default {
    name: 'CategoryItem',
    components: {ItemsItem},
    data () {
      return {
        pageCode: 'category',
        busy: false,
        category: null,
        items: [],
        item_next_page_url: 'http://admin.harigu.com/api/items?page=1&category_id=' + this.$route.params.category
      };
    },
    computed: {
      loading () {
        return this.$store.state.loading;
      }
    },
    methods: {
      async fetch () {
        if (this.busy) return;
        if (!this.item_next_page_url) return;
        this.busy = true;
        this.$store.commit('setLoading');
        const response = await axios.get(this.item_next_page_url);
        this.category = response.data.category;
        this.items = this.items.concat(response.data.items.data);
        this.item_next_page_url = response.data.items.next_page_url;
        this.$store.commit('resetLoading');
        this.busy = false;
      },
      loadMore: function () {

        // window.console.log('loadMore');
        // debounce(this.fetch, 500);
        // setTimeout(() => {
          this.fetch();
        // }, 1000);
      }
    },
    created () {
      this.fetch();
    }
  };
</script>

<style scoped lang="scss">
  .buttons {
    position: sticky;
    top: 48px;
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    z-index: 1;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
    &:after {
      clear: both;
    }
  }

  .items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .description {
    text-align: center;
    padding: 4rem 1rem;
  }
</style>
